import { render, staticRenderFns } from "./Structures.vue?vue&type=template&id=bff34d9a"
import script from "./Structures.vue?vue&type=script&lang=js"
export * from "./Structures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports